import * as Api from '../../../../api/Api';
import { useState } from 'react';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import SelectList from '../../../../Components/Select/SelectList';
import ChartFromServer from '../../../../Components/Charts/ChartFromServer';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getAnioComparativo, getListUnidadesEconomicas } from '../../../../Components/Utils/Utils';

function IndicadorComparativa({ tipoReporte }) {
    const [unidadEconomica, setUnidadEconomica] = useState(getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = getListUnidadesEconomicas();

    const [searchCebe, setSearchCebe] = useState(false)
    const [cebe, setCebe] = useState(null)
    const [refreshCebe, setRefreshCebe] = useState(false)

    const animatedComponents = makeAnimated();

    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = monthNames[currentDate.getMonth()];
    const yearold = getAnioComparativo();
    const day = currentDate.getDate();
    const token = useGetToken();

    const colorList = [
        "#4472C4",
        "#4472C4",
        "#F64E60",
        "#F64E60"
    ];

    const settings = {
        "disableTooltipX": false,
        "disableTooltipY": false,
        "disableLabelX": false,
        "disableLabelY": false,
        "tooltipDy": 0,
        "tooltipAft": "",
        "enableBullet": true,
        "circleBulletRadius": 5,
        "enableLegend": true,
        "widthColumn": 1,
        "strokeWidth": 2,
        "timeTotalAnimation": 20,
        "exportar": true,
        "titleYizq": "",
        "titleYder": "",
        "labelAdapterAxisYIzq": "",
        "labelAdapterAxisYDer": ""
    }

    const dataSeries = [
        {
            "name": "2023",
            "field": "montoAnioActual",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        },
        {
            "name": "2019",
            "field": "montoAnioPasado",
            "axis": "left",
            "typeSerie": "line",
            "tooltipPrev": "S/ ",
            "tooltipAft": ""
        }
    ];

    const [rubro, setRubro] = useState({});
    const [enableQuery, setEnableQuery] = useState(true);
    const onChangeRubro = (inputValue) => {
        setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for CharFromServer
        setRubro(inputValue);
    }

    const getOptionValueUnidadEconomica = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeUnidadEconomica = (inputValue) => {
        setUnidadEconomica(inputValue);
        setSearchCebe(true)
    }

    const onChangeCebe = (inputValue) => {
        setCebe(inputValue);
        setRefreshCebe(true)
    }

    return (
        <>
            {(tipoReporte.value === "ventaMensual" || tipoReporte.value === "ventaMensualM2" || tipoReporte.value === "ventaMensualCerrado") &&
                <div className="card my-5">
                    <div className="card-header border-0 pt-5">

                        <h3 className="card-title align-items-start flex-column">

                            {tipoReporte.value === "ventaMensual" && <span className="card-label fw-bolder text-gray-800">Evolución diaria de Ventas de {rubro.label}  {year}- {yearold}</span>}
                            {tipoReporte.value === "ventaMensualM2" && <span className="card-label fw-bolder text-gray-800">Evolución diaria de Ventas por m<sup>2</sup> de {rubro.label}  {year}- {yearold}</span>}
                            {tipoReporte.value === "ventaMensualCerrado" && <span className="card-label fw-bolder text-gray-800">Evolución diaria de Ventas del mes cerrado de {rubro.label}  {year}- {yearold}</span>}
                        </h3>

                        <div className="p-2" style={{ minWidth: "200px" }}>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                components={animatedComponents}
                                defaultValue={getOptionValueUnidadEconomica(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeUnidadEconomica)}
                            />
                        </div>

                        <div className="p-2" style={{ minWidth: "200px" }}>
                            <SelectList
                                title="CeBe"
                                classNamePrefix='filter'
                                apiService={Api.ListaCebe}
                                args={{ token: token, unidadEconomicaId: unidadEconomica.value }}
                                conditions={true || searchCebe}
                                setConditions={setSearchCebe}
                                handleChange={onChangeCebe}
                                multiple={false}
                                defaultSetterFunction={setCebe}
                                removeElement={'0'}
                            />
                        </div>
                    </div>

                    {
                        tipoReporte.value === "ventaMensual" &&
                        (
                            <>
                                <div className="card-body tab-content pt-4">
                                    {cebe &&
                                        <ChartFromServer
                                            setAuxData={null}
                                            apiService={Api.IndicadoresComparativaVentaAnual}
                                            args={{ rubroId: cebe.value, token: token, anioComparativo: yearold }}
                                            conditions={true}
                                            type="LinealMultiAxis"
                                            idContent={"comparativaVentaAnual_chart" + tipoReporte.value + unidadEconomica.label + cebe.value}
                                            dataSeries={dataSeries}
                                            colorList={colorList}
                                            settings={settings}
                                            classContent="chart400Height"
                                            setEnableQuery={null}
                                        >
                                        </ChartFromServer>
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        tipoReporte.value === "ventaMensualM2" &&
                        (
                            <>
                                <div className="card-body tab-content pt-0">
                                    {cebe &&
                                        <ChartFromServer
                                            setAuxData={null}
                                            apiService={Api.IndicadoresComparativaVentaAnualM2}
                                            args={{ rubroId: cebe.value, token: token, anioComparativo: yearold }}
                                            conditions={true}
                                            type="LinealMultiAxis"
                                            idContent={"comparativaVentaAnualM2_chart" + tipoReporte.value + unidadEconomica.label + cebe.value}
                                            dataSeries={dataSeries}
                                            colorList={colorList}
                                            settings={settings}
                                            classContent="chart400Height"
                                            setEnableQuery={null}
                                        >
                                        </ChartFromServer>
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        tipoReporte.value === "ventaMensualCerrado" &&
                        (
                            <>
                                <div className="card-body tab-content pt-0">
                                    {cebe &&
                                        <ChartFromServer
                                            setAuxData={null}
                                            apiService={Api.IndicadoresComparativaMesCerrado}
                                            args={{ rubroId: cebe.value, token: token, anioComparativo: yearold }}
                                            conditions={true}
                                            type="LinealMultiAxis"
                                            idContent={"comparativaVentaAnualM2_chart" + tipoReporte.value + unidadEconomica.label + cebe.value}
                                            dataSeries={dataSeries}
                                            colorList={colorList}
                                            settings={settings}
                                            classContent="chart400Height"
                                            setEnableQuery={null}
                                        >
                                        </ChartFromServer>
                                    }
                                </div>
                            </>
                        )
                    }
                </div>
            }
        </>
    )
}

export default IndicadorComparativa;
